import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import i18n from './localization/i18n.js'
import VBodyScrollLock from 'v-body-scroll-lock'
import { mapMutations } from 'vuex'
import VTooltip from 'v-tooltip'
import Rollbar from 'vue-rollbar'
import ErrorModal from '@/components/ErrorModal'
import VueMeta from 'vue-meta'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import AxiosProvider from './providers/AxiosProvider'

Vue.use(VueMeta)
Vue.use(VTooltip)
Vue.use(VueCookies)
Vue.use(VueI18n)
Vue.use(VBodyScrollLock)
Vue.use(Rollbar, {
  accessToken: '0de77713911840b484982c03a7102f35',
  captureUncaught: true,
  captureUnhandledRejections: true,
  // enabled: process.env.NODE_ENV === 'production',
  enabled: true,
  environment: process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.0',
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
})

const isIE11 = !!window.msCrypto
AxiosProvider.init(isIE11)
Vue.prototype.$beepAxios = AxiosProvider.getBeepAxios(isIE11)
Vue.prototype.$locationAxios = AxiosProvider.getLocationAxios(isIE11)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    ...mapMutations(['setIsLoading']),

    createModal ({ title, message, btnMessage, callback, clickOutsideHide }) {
      var Modal = Vue.extend(ErrorModal)
      const instance = new Modal({ propsData: { callback: callback, clickOutsideHide: clickOutsideHide } })
      instance.$slots.title = title
      instance.$slots.message = message
      instance.$slots.btnMessage = btnMessage
      const child = document.createElement('div')
      child.id = 'modal'
      document.querySelector('#modal-container').appendChild(child)
      instance.$mount('#modal')
    }
  }
})

new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')
